import { render, staticRenderFns } from "./gidselect.vue?vue&type=template&id=4a0579ab&scoped=true&"
import script from "./gidselect.vue?vue&type=script&lang=js&"
export * from "./gidselect.vue?vue&type=script&lang=js&"
import style0 from "./gidselect.vue?vue&type=style&index=0&id=4a0579ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0579ab",
  null
  
)

export default component.exports